export default __webpack_public_path__ + "static/media/certified-advisory.2f68b3d6.png";